export default "__VITE_ASSET__C5YTh8KR__"